import { Link } from 'react-router-dom';

interface IMenuUserProps {
    userName?: string;
}

function MenuUser({ userName }: IMenuUserProps) {
    if (typeof userName === 'string') {
        return (
            <div className="user-panel mt-3 pb-3 mb-3 d-flex align-items-center justify-content-center">
                <div className="info">
                    <Link className="d-block user-info-block" to="/">{userName}</Link>
                </div>
            </div>
        );
    }
    return null;
}

MenuUser.defaultProps = {
    userName: undefined,
};

export default MenuUser;
